import { env } from "./env"

// Supported locales must match Keycloak's configured locales
export const SUPPORTED_LOCALES = ['en', 'fr'] as const;
export const DEFAULT_LOCALE = 'en';

type SupportedLocale = typeof SUPPORTED_LOCALES[number];

const isSupportedLocale = (locale: string): locale is SupportedLocale => {
  return (SUPPORTED_LOCALES as readonly string[]).includes(locale);
};

const detectPreferredLocale = (): string => {
  const urlParams = new URLSearchParams(window.location.search);
  const urlLocale = urlParams.get('ui_locales');

  // Validate that the locale is supported, otherwise default to English
  if (urlLocale && isSupportedLocale(urlLocale)) {
    return urlLocale;
  }
  
  return DEFAULT_LOCALE;
};

export const getConfiguration = (overrideLocale?: string) => {
  const currentLocale = overrideLocale || detectPreferredLocale();
  const config = {
    client_id: "jane_id_dashboard",
    // NOTE: this is needed when Keycloak redirects back to the dashboard url after login
    // i.e. https://keycloak.jane-sso-keycloak.orb.local/realms/jane_sso/protocol/openid-connect/auth?...&ui_locales=fr redirects to https://dashboard.identity-dashboard.orb.local/?ui_locales=fr
    redirect_uri: `${env.REACT_APP_DASHBOARD_BASE_URL}/authenticate?ui_locales=${currentLocale}`,
    scope: "openid",
    authority: env.REACT_APP_KEYCLOAK_BASE_URL,
    service_worker_relative_url: "/OidcServiceWorker.js",
    service_worker_only: true,
    refresh_time_before_tokens_expiration_in_second: 40,
    // NOTE: this is needed to pass the locale from the dashboard url to the redirect keycloak url (keycloak login page) upon loading the page before login
    // i.e. https://dashboard.identity-dashboard.orb.local/?ui_locales=fr redirects to https://keycloak.jane-sso-keycloak.orb.local/realms/jane_sso/protocol/openid-connect/auth?...&ui_locales=fr
    extras: {
      ui_locales: currentLocale,
    },
  };
  
  return config;
};

export const configuration = getConfiguration();

